<template>
  <div class="section-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SectionCard'
}
</script>

<style scoped>
.section-card {
  background: #ffffff;
  padding: 48px;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.05);
  max-width: 800px;
  margin: 0 auto;
}

.section-card.faq-card {
  max-width: 900px;
}

@media (max-width: 768px) {
  .section-card {
    padding: 32px 24px;
  }
}
</style>

